import type { KnowledgeBaseFormData, KnowledgeBaseFormVisibility } from './knowledge-bases.types';

/**
 * The form with `spaceVisibility` switched, in one update. Choosing specified workspaces also
 * writes `ownWorkspaceId` into the list, when the caller passes one: on create the API adds the
 * caller's workspace whatever the request says, so the picker's count stays honest and sharing
 * with only your own workspace is reachable. Two separate updates cannot do this, since each
 * spreads the same render's form and the second one overwrites the first.
 */
export function withSpaceVisibility(
  data: KnowledgeBaseFormData,
  spaceVisibility: KnowledgeBaseFormVisibility,
  ownWorkspaceId?: string,
): KnowledgeBaseFormData {
  const seedsOwnWorkspace =
    spaceVisibility === 'workspaces' &&
    !!ownWorkspaceId &&
    !data.workspaceIds.includes(ownWorkspaceId);

  return {
    ...data,
    spaceVisibility,
    workspaceIds: seedsOwnWorkspace ? [ownWorkspaceId, ...data.workspaceIds] : data.workspaceIds,
  };
}
